"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERVIEW = void 0;
var OVERVIEW = {
  BUTTON__EDIT_PRODUCT_INFO: 'overview-button-editProductInfo',
  BUTTON__EDIT_TIER_PRICING: 'overview-button-editTierPricing',
  BUTTON__EDIT_PAR_LEVEL: 'overview-button-editParLevel',
  IMG__PRODUCT: 'overview-div-productImage',
  TEXT__NAME: 'overview-div-productName',
  TEXT__PRICE: 'overview-span-productPrice',
  TEXT__SKU: 'overview-span-productSKU',
  TEXT__CATEGORY: 'overview-span-productCategory',
  TEXT__PRODUCT_GROUP: 'overview-span-productGroup',
  TEXT__DESCRIPTION: 'overview-span-productDescription',
  TIER_PREVIEW: {
    TEXT__QUANTITY: 'overview-span-tierPricingPreviewQuantity',
    TEXT__PRICE: 'overview-span-tierPricingPreviewPrice'
  },
  SPECIAL_TIER_PREVIEW: {
    TEXT__NAME: 'overview-h5-specialTierPricingPreviewName',
    TEXT__QUANTITY: 'overview-span-specialTierPricingPreviewQuantity',
    TEXT__PRICE: 'overview-span-specialTierPricingPreviewPrice'
  }
};
exports.OVERVIEW = OVERVIEW;